import { render, staticRenderFns } from "./OVGListView.vue?vue&type=template&id=4c165810&scoped=true&lang=pug"
import script from "./OVGListView.vue?vue&type=script&lang=js"
export * from "./OVGListView.vue?vue&type=script&lang=js"
import style0 from "./OVGListView.vue?vue&type=style&index=0&id=4c165810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c165810",
  null
  
)

export default component.exports